/**
 * SQ PDP Kit Rotina — JavaScript interactions
 *
 * Phase 2a: Gallery, Sticky ATC, Bottom Sheet
 * Phase 2b will add: Accordions, FAQ tabs, Final CTA scroll
 */
(function () {
  'use strict';

  function init() {
    initDesktopHeroGrid();
    initGallery();
    initGalleryVideoAutoplay();
    initStickyAtc();
    initBottomSheet();
    initAccordions();
    initUgcVideos();
    initUgcAutoplay();
    initFaqTabs();
  }

  // ── Desktop Hero Grid: wrap gallery + buybox sections side-by-side ──
  // On ≥1024px, finds the two adjacent .shopify-section wrappers and groups
  // them in a CSS Grid container. Runs once on load; no resize listener needed
  // because the wrapper is always present — CSS handles show/hide via media query.
  function initDesktopHeroGrid() {
    var gallerySection = document.querySelector('[data-section-type="sq-pdp-gallery"]');
    var buyboxSection = document.querySelector('[data-section-type$="buybox"]');
    if (!gallerySection || !buyboxSection) return;

    // Walk up to the .shopify-section wrapper
    var galleryWrapper = gallerySection.closest('.shopify-section');
    var buyboxWrapper = buyboxSection.closest('.shopify-section');
    if (!galleryWrapper || !buyboxWrapper) return;

    // Only wrap if they are adjacent siblings (buybox immediately follows gallery)
    if (galleryWrapper.nextElementSibling !== buyboxWrapper) return;

    var grid = document.createElement('div');
    grid.className = 'sq-pdp-hero-grid';
    galleryWrapper.parentNode.insertBefore(grid, galleryWrapper);
    grid.appendChild(galleryWrapper);
    grid.appendChild(buyboxWrapper);
  }

  // ── Gallery: sync thumbnails with scroll + counter ──
  function initGallery() {
    var galleries = document.querySelectorAll('[data-section-type="sq-pdp-gallery"]');

    galleries.forEach(function (section) {
      var sectionId = section.dataset.sectionId;
      var main = document.getElementById('galleryMain-' + sectionId);
      var thumbs = section.querySelectorAll('.gallery-thumb');
      var counter = document.getElementById('galleryCounter-' + sectionId);
      var totalSlides = section.querySelectorAll('.gallery-slide').length;

      if (!main || !thumbs.length) return;

      function updateActive(index) {
        thumbs.forEach(function (t, i) {
          t.classList.toggle('active', i === index);
          if (i === index) {
            t.setAttribute('aria-current', 'true');
          } else {
            t.removeAttribute('aria-current');
          }
        });
        if (counter) {
          counter.textContent = (index + 1) + ' / ' + totalSlides;
        }
      }

      // Scroll-based slide detection
      var scrollTimeout;
      main.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var idx = Math.round(main.scrollLeft / main.clientWidth);
          updateActive(idx);
        }, 60);
      });

      // Thumbnail click → scroll to slide
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = parseInt(thumb.dataset.index, 10);
          main.scrollTo({ left: idx * main.clientWidth, behavior: 'smooth' });
          updateActive(idx);
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    });
  }

  // ── Gallery Videos: autoplay when scrolled into view ──
  function initGalleryVideoAutoplay() {
    var videos = document.querySelectorAll('.js-gallery-video');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  // ── Sticky ATC: show when main ATC scrolls out of view ──
  function initStickyAtc() {
    var mainAtc = document.querySelector('[data-section-type$="buybox"] .pdp-atc');
    var stickyBar = document.querySelector('[data-section-type="sq-pdp-sticky-atc"] .sticky-atc');

    if (!mainAtc || !stickyBar || !('IntersectionObserver' in window)) return;

    var mainAtcSeen = false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          mainAtcSeen = true;
          stickyBar.classList.remove('visible');
        } else if (mainAtcSeen) {
          stickyBar.classList.add('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }

  // ── Bottom Sheet: open/close with touch-to-dismiss ──
  function initBottomSheet() {
    var buyboxSections = document.querySelectorAll('[data-section-type="sq-pdp-buybox"]');

    buyboxSections.forEach(function (section) {
      var sectionId = section.dataset.sectionId;
      var infoBtn = document.getElementById('infoBtn-' + sectionId);
      var sheet = document.getElementById('bottomSheet-' + sectionId);
      var backdrop = document.getElementById('sheetBackdrop-' + sectionId);
      var closeBtn = document.getElementById('sheetClose-' + sectionId);

      if (!infoBtn || !sheet || !backdrop || !closeBtn) return;

      function openSheet() {
        sheet.classList.add('open');
        backdrop.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      function closeSheet() {
        sheet.classList.remove('open');
        backdrop.classList.remove('open');
        document.body.style.overflow = '';
      }

      infoBtn.addEventListener('click', openSheet);
      closeBtn.addEventListener('click', closeSheet);
      backdrop.addEventListener('click', closeSheet);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sheet.classList.contains('open')) {
          closeSheet();
        }
      });

      // Touch-to-dismiss: swipe down to close
      var touchStartY = 0;
      sheet.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      sheet.addEventListener('touchend', function (e) {
        var diff = e.changedTouches[0].clientY - touchStartY;
        if (diff > 80) closeSheet();
      }, { passive: true });
    });
  }

  // ── Accordions: exclusive toggle (one open at a time per group) ──
  // Handles both product info accordions (.info-acc-question) and FAQ accordions (.faq-question)
  function initAccordions() {
    var buttons = document.querySelectorAll('.sq-pdp .info-acc-question, .sq-pdp .faq-question');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var wasOpen = item.classList.contains('open');
        var container = item.parentElement;

        // Close all siblings in the same accordion group
        if (container) {
          container.querySelectorAll('.info-acc-item.open, .faq-item.open').forEach(function (openItem) {
            if (openItem !== item) openItem.classList.remove('open');
          });
        }

        // Toggle the clicked item
        item.classList.toggle('open', !wasOpen);
      });
    });
  }

  // ── UGC Videos: fullscreen modal on card tap ──
  function initUgcVideos() {
    var sections = document.querySelectorAll('[data-section-type$="buybox"]');

    sections.forEach(function (section) {
      var sectionId = section.dataset.sectionId;
      var cards = section.querySelectorAll('[data-video-src]');
      var modal = document.getElementById('ugcModal-' + sectionId);

      if (!modal || !cards.length) return;

      var backdrop = modal.querySelector('.ugc-modal-backdrop');
      var closeBtn = modal.querySelector('.ugc-modal-close');
      var modalVideo = modal.querySelector('.ugc-modal-video');

      function openModal(videoSrc) {
        modalVideo.innerHTML = '';
        var source = document.createElement('source');
        source.src = videoSrc;
        source.type = 'video/mp4';
        modalVideo.appendChild(source);
        modalVideo.muted = false;
        modalVideo.load();
        modalVideo.play();
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('open');
        modalVideo.pause();
        modalVideo.innerHTML = '';
        document.body.style.overflow = '';
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var src = card.dataset.videoSrc;
          if (src) openModal(src);
        });
      });

      closeBtn.addEventListener('click', closeModal);
      backdrop.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) {
          closeModal();
        }
      });
    });
  }

  // ── UGC Videos: lazy autoplay via IntersectionObserver ──
  function initUgcAutoplay() {
    var videos = document.querySelectorAll('.js-ugc-video');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var tryPlay = function () { video.play().catch(function () {}); };
          if (video.readyState >= 3) {
            tryPlay();
          } else {
            video.addEventListener('canplay', tryPlay, { once: true });
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.15, rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });

    var ugcCarousel = document.querySelector('.ugc-scroll');
    if (ugcCarousel) {
      var warmedUp = false;
      function warmUpUgcVideos() {
        if (warmedUp) return;
        warmedUp = true;
        var ugcVids = ugcCarousel.querySelectorAll('.js-ugc-video');
        ugcVids.forEach(function (v) {
          v.preload = 'auto';
          v.load();
        });
      }
      ugcCarousel.addEventListener('touchstart', warmUpUgcVideos, { once: true, passive: true });
      ugcCarousel.addEventListener('pointerdown', warmUpUgcVideos, { once: true });
      ugcCarousel.addEventListener('scroll', warmUpUgcVideos, { once: true, passive: true });

      if ('IntersectionObserver' in window) {
        var warmUpObserver = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            warmUpUgcVideos();
            warmUpObserver.disconnect();
          }
        }, { rootMargin: '600px 0px' });
        warmUpObserver.observe(ugcCarousel);
      }
    }
  }

  // ── FAQ: tab switching ──
  function initFaqTabs() {
    var sections = document.querySelectorAll('[data-section-type$="faq"]');

    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.faq-tab');
      var panels = section.querySelectorAll('.faq-panel');

      if (!tabs.length || !panels.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tab;
          tabs.forEach(function (t) {
            t.classList.toggle('active', t === tab);
          });
          panels.forEach(function (p) {
            p.classList.toggle('active', p.id === 'panel-' + target);
          });
        });
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
